<template>
    <div class="">
        <div class="problem-content bgfff">
            <h2 class="title">常见问题</h2>
            <div class="problem">
				<dl>
                    <dt class="clearfix">
                        <i class="icons1 ask fl"></i>
                        <div class="qs hidden">如何申请成为机构版用户？</div>
                    </dt>
                    <dd class="mt15 clearfix">
                        <div class="qs hidden">
                            <p>在我的会员-会员购买页面可以查看机构版用户的权限，升级机构版用户可以扫描下方微信二维码联系客服开通。</p>
                            <p class="tc"><img src="/static/images/kefu.png" width="150" height="150" class="mt20"/></p>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt class="clearfix">
                        <i class="icons1 ask fl"></i>
                        <div class="qs hidden">为什么媒体号授权后无法发文，查看数据？</div>
                    </dt>
                    <dd class="mt15 clearfix">
                        <div class="qs hidden">
                            <p>公众号需是认证公号授权后才可发文、查看数据，未认证的公众号不能进行任何操作；</p>
                            <p>微博目前只支持发布微博头条文章</p>
                            <p>经过实名认证的头条账号才可发文</p>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt class="clearfix">
                        <i class="icons1 ask fl"></i>
                        <div class="qs hidden">为什么之前已授权的媒体号过段时间会授权失效？</div>
                    </dt>
                    <dd class="mt15 clearfix">
                        <div class="qs hidden">
                            <p>公众号授权后，管理员不取消授权，一般不会授权失效。微博和头条受平台机制影响，授权超一个月需要重新授权。</p>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt class="clearfix">
                        <i class="icons1 ask fl"></i>
                        <div class="qs hidden">购买了V1会员，还没有过期，这时想要升级为V2会员怎么操作？</div>
                    </dt>
                    <dd class="mt15 clearfix">
                        <div class="qs hidden">
                            <p>可以直接至会员购买页，进行会员升级购买。</p>
                            <p>当前未到期的会员剩余天数会自动换算为清贝，抵扣会员升级时的购买价格。</p>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt class="clearfix">
                        <i class="icons1 ask fl"></i>
                        <div class="qs hidden">编辑器为什么都是微信格式的？</div>
                    </dt>
                    <dd class="mt15 clearfix">
                        <div class="qs hidden">
                            <p>当前版本文章编辑只支持按照微信公众号文章格式，会在后续版本中会兼容更多的格式。</p>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt class="clearfix">
                        <i class="icons1 ask fl"></i>
                        <div class="qs hidden">发布指令模块的任务文章为什么只能插入微信文章？</div>
                    </dt>
                    <dd class="mt15 clearfix">
                        <div class="qs hidden">
                            <p>插入文章源，当前版本只支持微信公众号内的文章，会在后续版本中会兼容更多的格式。</p>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt class="clearfix">
                        <i class="icons1 ask fl"></i>
                        <div class="qs hidden">之前是V1用户，升级到机构版用户怎么操作，之前授权的账号会怎么样？</div>
                    </dt>
                    <dd class="mt15 clearfix">
                        <div class="qs hidden">
                            <p>V1用户升级到机构版用户，当前未到期的会员剩余天数会自动换算为清贝，抵扣会员升级时的购买价格，之前授权的公众号会同步到机构版中。</p>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt class="clearfix">
                        <i class="icons1 ask fl"></i>
                        <div class="qs hidden">之前是V1用户，被拉到机构版分组里，之前的权限会怎么样？</div>
                    </dt>
                    <dd class="mt15 clearfix">
                        <div class="qs hidden">
                            <p>V1用户被拉到机构版分组里，之前未到期的会员权益会被冻结，从机构版分组里脱离时，冻结权益重新启用。</p>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt class="clearfix">
                        <i class="icons1 ask fl"></i>
                        <div class="qs hidden">清博管家支持管理哪些平台？</div>
                    </dt>
                    <dd class="mt15 clearfix">
                        <div class="qs hidden">
                            <p>目前支持微信公众平台、今日头条、微博平台，会在后续版本中会兼容更多的平台。</p>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt class="clearfix">
                        <i class="icons1 ask fl"></i>
                        <div class="qs hidden">机构版账号删除后会怎么样？</div>
                    </dt>
                    <dd class="mt15 clearfix">
                        <div class="qs hidden">
                            <p>机构版初始账号，不可删除，权限不可修改。机构版其他账号删除后，回到加入机构版之前的权限。</p>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt class="clearfix">
                        <i class="icons1 ask fl"></i>
                        <div class="qs hidden">文章多平台发布怎么操作？</div>
                    </dt>
                    <dd class="mt15 clearfix">
                        <div class="qs hidden">
                            <p>在编辑器中编辑文章后，点击“发布文章”，或者在我的素材中点击“发布文章”后，选择需要发布文章的媒体号即可，可选择多个平台的媒体号。</p>
                        </div>
                    </dd>
                </dl>
                <dl>
                    <dt class="clearfix">
                        <i class="icons1 ask fl"></i>
                        <div class="qs hidden">账号标签在哪里添加？</div>
                    </dt>
                    <dd class="mt15 clearfix">
                        <div class="qs hidden">
                            <p>在账号列表界面，点击右侧管理标签按钮，进入账号标签标注界面，每个媒体号最多可标注三个标签。</p>
                        </div>
                    </dd>
                </dl>
            </div>
        </div>

    </div>
</template>
<script>
export default {
    name: "left",
    props: "",
    data() {
        return {
            
        }
    },
    mounted() {
        
    },
    created() {
		
    },
    methods: {
        myNews(e){
            window.open(e,'_blank');
        },
        
    }
}
</script>
<style lang="">
    .index-content{padding-top:116px;}
    .ask{background-position:0 -32px;margin:0 15px 0 0;}
	.problem{}
	.erweima{position:absolute;right:20px;}
    .problem-content{width:1200px;margin:89px auto 20px;position:relative;}
    .problem-content .title{margin-bottom:25px;}
    .problem dt{margin-left:15px;}
    .problem dt .qs{font-size:16px;}
    .problem dd .qs{color:#8a8a99;margin-bottom:15px;padding:0 0 15px 50px;border-bottom:1px solid #ddd;}
	
</style>



// WEBPACK FOOTER //
// src/page/problem.vue